<body data-spy="scroll" data-target="#main-nav" id="home">
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark fixed-top" id="main-nav">
    <div class="container">
      <a class="navbar-brand">
        <div class="logo">
          <img src="../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="">
        </div>
      </a>
      <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mx-2">
            <a href="#home" class="nav-link">Home</a>
          </li>
          <li class="nav-item mx-2">
            <a href="#subjects-section" class="nav-link">Subjects</a>
          </li>
          <li class="nav-item mx-2">
            <a href="#services-section" class="nav-link">Services</a>
          </li>
          <!-- <li class="nav-item mx-2">
            <a
              href="#"
              class="nav-link"
              data-toggle="modal"
              data-target="#bookAppointmentModal"
              (click)="onBookAppointment()">
                Book an Appointment
            </a>
          </li> -->
          <li class="nav-item mx-2">
            <a
              href="#"
              class="nav-link"
              routerLink="/book">
                Book an Appointment
            </a>
          </li>
          <li class="nav-item mx-2">
            <a href="mailto:yourstutor17@gmail.com" style="cursor: pointer;" class="nav-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383l-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
              </svg> yourstutor17@gmail.com
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- HOME SECTION -->
  <header id="home-section">
    <div class="dark-overlay">
      <div class="home-inner container">
        <div class="row">
          <div class="col-lg-7 d-none d-lg-block">
            <h1 class="display-5">
              {{ contentTitle }}
            </h1>
            <div class="d-flex mt-5">
              <div class="p-4 align-self-start">
                <i class="fas fa-check fa-2x"></i>
              </div>
              <div class="p-4 align-self-end">
                <p style="font-size: 25px;">{{ contentPoint1 }}</p>
              </div>
            </div>

            <div class="d-flex">
              <div class="p-4 align-self-start">
                <i class="fas fa-check fa-2x"></i>
              </div>
              <div class="p-4 align-self-end">
                <p style="font-size: 25px;">{{ contentPoint2 }}</p>
              </div>
            </div>

            <div class="d-flex">
              <div class="p-4 align-self-start">
                <i class="fas fa-check fa-2x"></i>
              </div>
              <div class="p-4 align-self-end">
                <p style="font-size: 25px;">{{ contentPoint3 }}</p>
              </div>
            </div>
          </div>

          <!-- Query form -->
          <div class="col-lg-5">
            <div class="card bg-primary text-center card-form">
              <div class="card-body">
                <h3>Got A Query?</h3>
                <p>Fill this form you will hear from our tutor in 5 mins or less with a quote</p>
                <div class="form-group">
                  <input
                    type="number"
                    class="form-control form-control-lg"
                    placeholder="Mobile number*"
                    [(ngModel)]="queryData.mobileNumber">
                </div>
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control form-control-lg"
                    placeholder="Email*"
                    [(ngModel)]="queryData.email">
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-control-lg"
                    placeholder="Full Name*"
                    [(ngModel)]="queryData.fullName">
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control form-control-lg"
                    placeholder="Subject*"
                    [(ngModel)]="queryData.subject">
                </div>
                <div class="form-group">
                  <textarea
                    class="form-control form-control-lg"
                    rows="2"
                    placeholder="Message*"
                    [(ngModel)]="queryData.message">
                  </textarea>
                </div>
                <div class="form-group">
                  <input type="file" class="form-control form-control-file form-control-lg"
                  #exampleFormControlFile1
                  id="exampleFormControlFile1"
                  (change)="onUploadFile($event)">
                </div>
                <p *ngIf="emptyQueryFieldError===true">*Enter values in all fields!</p>
                <p *ngIf="querySubmitted===true">{{ queryResponseMessage }}</p>
                <p *ngIf="fileUploadError!=''" style="color: red;">{{fileUploadError}}</p>
                <input type="submit" value="Submit" (click)="onSubmit()" class="btn btn-outline-light btn-block">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- TAG LINE SECTION -->
  <section id="tag-line-section">
    <div class="container">
      <div class="row">
        <div class="col text-center py-5">
          <h1 class="display-4">{{ tagHeading }}</h1>
          <p class="lead">{{ tagLine }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- SUBJECTS SECTION -->
  <section id="subjects-section" class="py-5">
    <div class="container">
      <div class="row">
        <div class="text-center pb-5" style="color: black;">
          <h1 class="display-4">Our Subjects</h1>
        </div>
        <div class="col-md-4 pb-5" *ngFor="let subject of subjectsList">
          <div class="card text-center">
            <div class="card-header bg-dark text-white">
              <h3 class="mt-1">{{ subject.title }}</h3>
            </div>
            <div class="card-body" style="color: black;">
              <ul class="list-group">
                <li class="list-group-item" *ngIf="subject.details[0]">
                  <i class="fas fa-check"></i> {{ subject.details[0] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[1]">
                  <i class="fas fa-check"></i> {{ subject.details[1] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[2]">
                  <i class="fas fa-check"></i> {{ subject.details[2] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[3]">
                  <i class="fas fa-check"></i> {{ subject.details[3] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[4]">
                  <i class="fas fa-check"></i> {{ subject.details[4] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[5]">
                  <i class="fas fa-check"></i> {{ subject.details[5] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[6]">
                  <i class="fas fa-check"></i> {{ subject.details[6] }}
                </li>
                <li class="list-group-item" *ngIf="subject.details[7]">
                  <i class="fas fa-check"></i> {{ subject.details[7] }}
                </li>
              </ul>
              <a href="#home" class="btn btn-primary btn-block mt-3">Get a Quote</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SERVICES SECTION -->
  <section id="services-section" class="bg-primary">
    <div class="container">
      <div class="row">
        <div class="col text-center py-5">
          <h1 class="display-4">Our Services</h1>
        </div>
      </div>
      <div class="row pb-5">
        <div class="col-md-3 pb-3" *ngFor="let service of servicesList">
          <div class="card bg-primary text-white text-center" style="border: 1px solid white;">
            <div class="card-body">
              <i class="fas fa-users fa-3x pb-3"></i>
              <h4 class="pb-3">{{ service.title }}</h4>
              {{ service.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FOOTER -->
  <footer id="main-footer" class="bg-dark">
    <div class="container text-center">
      <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12 pb-2">
          <div class="row">
            <div class="col pt-4 pb-2">
              <p>
                <a style="cursor: pointer; text-decoration: none; color: white; text-decoration: underline;" routerLink="/contact-us">
                  <u>Contact Us</u>
                </a>
              </p>
              <p>
                <a style="cursor: pointer; text-decoration: none; color: white; text-decoration: underline;" routerLink="/terms-and-conditions">
                  <u>Terms & conditions</u>
                </a>
              </p>
            </div>
            
            <div class="col pt-4 pb-2">
              <a style="cursor: pointer; text-decoration: none; color: white; text-decoration: underline;" routerLink="/privacy-policy">
                <p><u>Privacy Policy</u></p>
              </a>
              <p>
                <a style="cursor: pointer; text-decoration: none; color: white; text-decoration: underline;" routerLink="/cancellation-policy">
                  <u>Cancellation Policy</u>
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 pt-4 pb-2">
          <div class="logo mb-2" style="margin: auto; width: 60px;">
            <img src="../../assets/WhatsApp Image 2022-08-02 at 5.41.07 AM.jpeg" alt="">
          </div>
          <p>Copyright &copy; {{ currentYear }}.
            
            All rights reserved.
            <span id="year"></span>
          </p>
        </div>
        
        
      </div>
      <!-- <div class="row">
        <div class="col text-end">
          <button class="btn btn-sm btn-dark mb-3" routerLink="/admin">YoursTutors Admin</button>
        </div>
        <div class="col text-start">
          <button class="btn btn-sm btn-dark mb-3" routerLink="/ecademic/admin">Ecademictube Admin</button>
        </div>
      </div> -->
    </div>
  </footer>

</body>


<!-- Terms & Conditions Modal -->
<!-- <div class="modal fade" id="termsAndConditionsModal" tabindex="-1" role="dialog" aria-labelledby="terms&ConditionsModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="white-space: pre-line;">{{ termsAndConditions }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

<!-- Privacy Policy Modal -->
<!-- <div class="modal fade" id="privacyPolicyModal" tabindex="-1" role="dialog" aria-labelledby="terms&ConditionsModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Privacy Policy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="white-space: pre-line;">{{ privacyPolicy }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

<!-- Cancellation Policy Modal -->
<!-- <div class="modal fade" id="cancellationPolicyModal" tabindex="-1" role="dialog" aria-labelledby="cancellationPolicyModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Cancellation Policy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="white-space: pre-line;">{{ cancellationPolicy }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

